import { render, staticRenderFns } from "./toolbar.vue?vue&type=template&id=86548e2c"
import script from "./js/toolbar.js?vue&type=script&lang=js&external"
export * from "./js/toolbar.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.34_babel-core@7.0.0-bridge.0_@babel+core@7.29._9691e8a1bbcd57691b862420a6e71e49/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports